<template>
    <div>
        <h1>{{ $t('bestillingsbekr')}}</h1>
        <!-- <p>URLParams: {{ this.URLParams }}</p> -->





        <table width="80%" border="0" cellpadding="10" cellspacing="10" bgcolor="#FFFFFF" align="center" style="max-width: 850px;">
            <tr>
                <td align="right" valign="top">
                    <!-- Hvis kundens logo ikke findes, så vis et default logo -->
                    <!-- <img v-bind:src="this.backendurl+'/storage/'+this.URLParams.bookingInProgress.hotel+'.png'" alt="Logo" @error="defaultLogo"> -->
                    <img v-bind:src="this.backendurl+'/storage/'+this.URLParams.bookingInProgress.hotel+'.png'" alt="Logo">
                </td>
            </tr>

            <tr>
                <td align="center" valign="top">
                    <!-- <h2 style="font-weight: 100; margin-bottom: 5px;">{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['tak']) }}</h2> -->
                    <h2 style="font-weight: 100; margin-bottom: 5px;">{{ $t('takfortilkoeb') }}</h2>
                    <b>{{ this.URLParams.bookingInProgress.hotelname }}</b>

                    <!-- <p>{{ this.$store.getters.bookingSummary['texts']['invoiceAttached'] }}</p> -->
                    <!-- <p>Du kan hente din faktura <a v-bind:href="axios.defaults.baseURL+'/koncern/'+this.$route.params.koncern+'/booking/'+ this.$route.params.refno +'/pdf'">her</a></p> -->
                    <br>
                    <br>

                    <table width="100%" bgcolor="#dff0f5" border="0">
                        <tr>
                            <td align="center">
                                <table border="0" cellpadding="5" cellspacing="5" bgcolor="#dff0f5" style="margin-left: 0px; margin-right: 0px; width: 85%; max-width: 300px;">
                                    
                                    <tr>
                                        <td align="right" valign="top">
                                            <img alt="Door code" v-bind:src="this.backendurl+'/storage/noter.png'" height="75" width="75">
                                        </td>
                                        <td colspan="3" align="left" valign="top" style="vertical-align: top;">
                                            <!-- <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['doorcode']) }} {{ this.$store.getters.bookingSummary['doorcode'] }} #</b><br> -->
                                            <p>{{ $t('viharregistreret') }} {{ this.URLParams.bookingInProgress.fakturanr }}</p>
                                            <!-- <i>{{ this.$store.getters.bookingSummary['texts']['rememberThis'] }}</i> -->
                                            <!-- <i>Husk dørkoden</i> -->
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <br>
                    <br>
                    <br>

                    <table border="0" cellspacing="0" width="100%">
                        <tr>
                            <td width="800" align="center">
                                <table width="100%" style="border-collapse: collapse; max-width: 800px;">
                                  <!-- {{-- Værelser --}} -->
                                  <tr style="border-bottom: 1px solid black;" v-if="this.URLParams.bookingInProgress.ekstrasSummary && this.URLParams.bookingInProgress.ekstrasSummary.length > 0">
                                    <td>

                                    </td>
                                    <td>
                                        <!-- <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['room']) }}</b> -->
                                        <b style="text-transform: capitalize;">{{ $t('ekstra') }}</b>
                                    </td>
                                    <td>
                                        <!-- <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['arrival']) }}</b> -->
                                        <b style="text-transform: capitalize;">{{ $t('dato') }}</b>
                                    </td>
                                    <td>
                                        <!-- <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['departure']) }}</b> -->
                                        <b style="text-transform: capitalize;">{{ $t('antal') }}</b>
                                    </td>
                                    <td><b style="text-transform: capitalize;">{{ $t('pris') }}</b></td>
                                </tr>

                                <!-- <tr style="border-bottom: 1px solid black;" v-for="bookingLine in this.bookingSummary.booking.rooms" v-bind:key="bookingLine.room"> -->
                                <!-- <tr style="border-bottom: 1px solid black;" v-for="bookingLine in computedBookingSummary.booking.rooms" v-bind:key="bookingLine.room"> -->
                                  <tr style="border-bottom: 1px solid black; padding-bottom: 3em;" v-for="(summary, key) in this.URLParams.bookingInProgress.ekstrasSummary" v-bind:key="key">
                                    <td>
                                        <!-- <img v-bind:src="backendurl+'/storage/ikon-'+ bookingLine.roomType +'.png'" alt="1" height="60" width="60" style="padding-top: 5px;"> -->
                                    </td>
                                    <td style="text-transform: capitalize;">
                                        <!-- {{ ucfirst(bookingSummary['texts']['room']) }} {{ bookingSummary['texts']['nr'] }} {{ bookingLine.room }} -->
                                        {{ summary.headline }}
                                    </td>

                                    <!-- <td>
                                        {{ bookingSummary['booking']['arrival'] }}
                                    </td> -->

                                    <td style="font-size: 80%;" v-if="Array.isArray(summary.date)">{{ summary.date.filter(date => date.checked == true).map(date => date.date).join(', ') }}</td>
                                    <td style="font-size: 80%;" v-else>{{ summary.date.date }}</td>
                                    <td>
                                        <!-- {{ bookingSummary['booking']['departure'] }} -->
                                        {{ summary.antal_personer }}
                                    </td>
                                    <td>
                                      {{ summary.antal_naetter * summary.price }}
                                    </td>
                                  </tr>
                                </table>

                                <br />
                                <!-- <b>{{ this.$store.getters.bookingSummary['texts']['bekr'] }}</b> -->
                                <!-- <b>Slut tekst</b> -->
                            </td>
                        </tr>
                    </table>                    
                </td>
            </tr>
        </table>












    </div>
</template>

<script>
import i18n from '@/plugins/i18n';
//import { throws } from 'assert';

export default {
    data() {
        return {
            locale: i18n.locale,
            apiLoaded: 0,
            hotel: this.$store.getters.afterAddonData.hotel,
            momssats: 19,
            totalPrice: 0,
            URLParams: null
        };
    },
    mounted() {
      if(this.$route.params.complete === 'complete') {
        console.log('Tilkøbet er betalt og registreret - vis data fra den booking der er angivet i routen')
      } else {
        if(this.$route.params.complete === 'initial') {
          // En betaling på tilkøb er netop gennemført

          // Start med at decode URLParams
          console.log('URLParams 1: '+JSON.stringify(this.$route.params.URLparams))
          var decodedURLParams = atob(this.$route.params.URLparams);
          this.URLParams = JSON.parse(decodedURLParams);
          console.log('URLParams 2: '+JSON.stringify(this.URLParams))

          // Her laver vi et API-kald til QuickPay og kontrollerer status på betalingen. 
          this.$store.dispatch("qpPayCheck", {'koncern': this.$route.params.koncern, 'postnr': this.URLParams.bookingInProgress.hotel, 'refNo': this.$route.params.refno}).then(
            () => {
              if(this.$store.getters.qpPayCheck.state === 'processed' || this.$store.getters.qpPayCheck.state === 'new') {
                if(this.$store.getters.qpPayCheck.test_mode === true) {
                  // For at acceptere booking med test kort:
                  this.mkAddonPurchase('c', this.URLParams.customerData, this.URLParams.bookingInProgress);
                  console.log('Kalder mkAddonPurchase efter betaling med test-kort med disse data:'+JSON.stringify(this.URLParams.customerData)+'samt bookingInProgress: '+JSON.stringify(this.URLParams.bookingInProgress))
                  //this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/administration/efterbestilling/faktura/'+this.$route.params.refno+'/complete/c' })

                  // For at afvise betaling med test kort:
                  //this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/cancel/' })
                  //console.log('payment ok... test mode...');
                } else {
                  this.mkAddonPurchase('c', this.URLParams.customerData, this.URLParams.bookingInProgress);
                  //console.log('payment ok...');
                }
              } else {
                this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/administration/efterbestilling/cancel/' })
                //console.log('payment not ok...');
              }
            } 
          );
        }
      }
    },
    methods: {
        getMomssats(hotels) {
            for (const [hotel] of Object.entries(hotels)) {
                if(this.$store.getters.afterAddonData.hotel == hotel.postnr) {
                    this.momssats = hotel.momssats;
                }
            }
        },
        mkAddonPurchase(paymentType, customerData, bookingInProgress) {
          console.log('Laver Add-On purchase med refno:');
          console.log(this.$route.params.refno);
            
          this.$store.dispatch("getAddonInvoice", {
            "koncern": this.$route.params.koncern,
            "refno": this.$route.params.refno,
            "paymentType": paymentType,
            "language": this.locale,
            "customer": customerData,
            "booking": bookingInProgress
            }).then(() => {
              this.$store.dispatch("getAddonSummary", {'refNo': this.$route.params.refno, 'koncern': this.$route.params.koncern}).then(() => { 
                this.apiLoaded = 1; 
                this.bookingSummary = this.$store.getters.bookingSummary;
                window.dataLayer.push({'event':'orderSuccess','orderTotal':  this.$store.getters.bookingSummary.booking.summary.inclVAT });   // Google Ads konverterings sporing
            });
                //this.$store.dispatch("getBookingSummary", this.refNo.refNo).then(() => { this.$router.push({ path: 'faktura/'+this.refNo.refNo }) });
            });            
        },
        ucfirst(string) {
            return string[0].toUpperCase() + string.substring(1);
        },
    }
}
</script>

<style scoped>
table {
  color: black;
  text-transform: none;
}


</style>